// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import App from './App.vue'
import router from './services/router'
import store from './services/store'
import i18n from './services/i18n'
import VueClipboard from 'vue-clipboard2'
import VueIntercom from 'vue-intercom'
import VueSanitize from 'vue-sanitize'
import Meta from 'vue-meta'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import VueGtm from 'vue-gtm'
import VueNativeSock from 'vue-native-websocket'

require('@simplecast/styles/global.scss')

Vue.config.productionTip = false

Vue.use(VueNativeSock, process.env.WS_PATH_GLOBAL, {
  reconnection: true,
  reconnectionAttempts: 5,
  store: store,
  format: 'json'
})

VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)
Vue.use(VueIntercom, { appId: process.env.INTERCOM_ID })
Vue.use(VueSanitize, {
  allowedTags: ['b', 'i', 'em', 'p', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'strong', 'blockquote', 'a', 'strike', 'br'],
  selfClosing: ['br', 'hr']
})

Vue.use(Meta, {
  keyName: 'metaInfo',
  attribute: 'data-vue-meta',
  ssrAttribute: 'data-vue-meta-server-rendered',
  tagIDKeyName: 'vmid'
})

// Google Tag Manager
// The env code stores double quotes as a value if it gets an empty value ¯\_(ツ)_/¯
if (process.env.GTM_ID && process.env.GTM_ID !== '' && process.env.GTM_ID !== '""') {
  Vue.use(VueGtm, {
    id: process.env.GTM_ID,
    router
  })
}

// Send In Blue
if (process.env.SEND_IN_BLUE_ID && process.env.SEND_IN_BLUE_ID !== '') {
  /* eslint-disable */
  window.sib = { equeue: [], client_key: process.env.SEND_IN_BLUE_ID };
  window.sendinblue = {}; for (var j = ['track', 'identify', 'trackLink', 'page'], i = 0; i < j.length; i++) { (function(k) { window.sendinblue[k] = function() { var arg = Array.prototype.slice.call(arguments); (window.sib[k] || function() { var t = {}; t[k] = arg; window.sib.equeue.push(t);})(arg[0], arg[1], arg[2]);};})(j[i]);}var n = document.createElement("script"),i = document.getElementsByTagName("script")[0]; n.type = "text/javascript", n.id = "sendinblue-js", n.async = !0, n.src = "https://sibautomation.com/sa.js?key=" + window.sib.client_key, i.parentNode.insertBefore(n, i), window.sendinblue.page();
  /* eslint-enable */
}

// This could possibly be moved into a `filters` file?
Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

if (process.env.SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    environment: process.env.SENTRY_ENV,
    integrations: [new Integrations.Vue({
      Vue,
      attachProps: true
    })],
    release: process.env.RELEASE,
    ignoreErrors: [
      // Random plugins/extensions
      'top.GLOBALS',
      // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
      'originalCreateNotification',
      'canvas.contentDocument',
      'MyApp_RemoveAllHighlights',
      'http://tt.epicplay.com',
      'Can\'t find variable: ZiteReader',
      'jigsaw is not defined',
      'ComboSearch is not defined',
      'http://loading.retry.widdit.com/',
      'atomicFindClose',
      // Facebook borked
      'fb_xd_fragment',
      // ISP 'optimizing' proxy - `Cache-Control: no-transform` seems to
      // reduce this. (thanks @acdha)
      // See http://stackoverflow.com/questions/4113268
      'bmi_SafeAddOnload',
      'EBCallBackMessageReceived',
      // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
      'conduitPage',
      'TypeError'
    ],
    // TODO: update sentry dependency, and change name to `denyUrls`
    blacklistUrls: [
      // Facebook flakiness
      /graph\.facebook\.com/i,
      // Facebook blocked
      /connect\.facebook\.net\/en_US\/all\.js/i,
      // Woopra flakiness
      /eatdifferent\.com\.woopra-ns\.com/i,
      /static\.woopra\.com\/js\/woopra\.js/i,
      // Chrome extensions
      /extensions\//i,
      /^chrome:\/\//i,
      // Other plugins
      /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
      /webappstoolbarba\.texthelp\.com\//i,
      /metrics\.itunes\.apple\.com\.edgesuite\.net\//i
    ]
  })
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: { App },
  template: '<App/>'
})
